function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.5,
  cy: 11.7109,
  rx: 11.5,
  ry: 11.4867,
  fill: "var(--color-input-border)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.73939 10.8991C5.29105 10.4512 4.56456 10.4517 4.11673 10.9C3.66891 11.3484 3.66932 12.0748 4.11767 12.5227L5.73939 10.8991ZM9.03567 15.8133L8.22481 16.6251L9.03567 17.435L9.84653 16.6251L9.03567 15.8133ZM18.0608 8.42026C18.5092 7.97243 18.5096 7.24594 18.0618 6.7976C17.6139 6.34926 16.8874 6.34884 16.4391 6.79666L18.0608 8.42026ZM4.11767 12.5227L8.22481 16.6251L9.84653 15.0015L5.73939 10.8991L4.11767 12.5227ZM9.84653 16.6251L18.0608 8.42026L16.4391 6.79666L8.22481 15.0015L9.84653 16.6251Z",
  fill: "white"
});
function SvgIcnCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCheckboxChecked);
export default __webpack_public_path__ + "static/media/icn-checkbox-checked.6aba00dbe3738f962a8bc3205dca0876.svg";
export { ForwardRef as ReactComponent };